import { render } from "./DerechoPolizaAviso.vue?vue&type=template&id=3da83608"
import script from "./DerechoPolizaAviso.vue?vue&type=script&lang=js"
export * from "./DerechoPolizaAviso.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__